var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter-container" },
    [
      _c(
        "md-button",
        {
          staticClass: "md-primary md-just-icon md-round filter-button",
          on: {
            click: function ($event) {
              _vm.showFilters = !_vm.showFilters
            },
          },
        },
        [_c("md-icon", [_vm._v("filter_list")])],
        1
      ),
      _c("span", { staticClass: "filter-label" }, [_vm._v(_vm._s(_vm.title))]),
      _vm.showFilters
        ? _c("div", { staticClass: "filter-dropdown" }, [
            _c(
              "div",
              { staticClass: "filter-header" },
              [
                _c("h4", [_vm._v(_vm._s(_vm.title))]),
                _c(
                  "md-button",
                  {
                    staticClass: "md-simple md-just-icon",
                    on: { click: _vm.closeFilter },
                  },
                  [_c("md-icon", [_vm._v("close")])],
                  1
                ),
              ],
              1
            ),
            _c("div", { staticClass: "filter-body" }, [
              _vm.dateRangeFilters.length > 0
                ? _c(
                    "div",
                    { staticClass: "filter-grid" },
                    _vm._l(
                      _vm.dateRangeFilters,
                      function (dateRangeFilter, index) {
                        return _c(dateRangeFilter.component, {
                          key: index,
                          ref: "filterComponents",
                          refInFor: true,
                          tag: "component",
                          attrs: {
                            id: dateRangeFilter.id,
                            "default-value": dateRangeFilter.defaultValue,
                            label: dateRangeFilter.label,
                            "current-filter-value":
                              _vm.getCurrentFilterValue(dateRangeFilter),
                          },
                          on: { change: _vm.handleFilterChange },
                        })
                      }
                    ),
                    1
                  )
                : _vm._e(),
              _vm.standardFilters.length > 0
                ? _c(
                    "div",
                    { staticClass: "filter-grid" },
                    _vm._l(
                      _vm.standardFilters,
                      function (standardFilter, index) {
                        return _c(standardFilter.component, {
                          key: index,
                          ref: "filterComponents",
                          refInFor: true,
                          tag: "component",
                          attrs: {
                            id: standardFilter.id,
                            title: standardFilter.title,
                            label: standardFilter.label,
                            placeholder: standardFilter.placeholder,
                            value: standardFilter.defaultValue,
                            options: standardFilter.options,
                            "current-filter-value":
                              _vm.getCurrentFilterValue(standardFilter),
                          },
                          on: { change: _vm.handleFilterChange },
                        })
                      }
                    ),
                    1
                  )
                : _vm._e(),
              _vm.checkboxFilters.length > 0
                ? _c(
                    "div",
                    { staticClass: "checkbox-filters-section" },
                    _vm._l(
                      _vm.checkboxFilters,
                      function (checkboxFilter, index) {
                        return _c(checkboxFilter.component, {
                          key: index,
                          ref: "filterComponents",
                          refInFor: true,
                          tag: "component",
                          attrs: {
                            id: checkboxFilter.id,
                            label: checkboxFilter.label,
                            value: checkboxFilter.defaultValue,
                            "current-filter-value":
                              _vm.getCurrentFilterValue(checkboxFilter),
                          },
                          on: { change: _vm.handleFilterChange },
                        })
                      }
                    ),
                    1
                  )
                : _vm._e(),
            ]),
            _c(
              "div",
              { staticClass: "filter-footer" },
              [
                _c(
                  "md-button",
                  {
                    staticClass: "md-default",
                    on: { click: _vm.resetFilters },
                  },
                  [_vm._v("Reset")]
                ),
                _c(
                  "md-button",
                  {
                    staticClass: "md-primary",
                    on: { click: _vm.applyFilters },
                  },
                  [_vm._v("Apply")]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }